'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var FEATURE_QUERY_VALUE = 'feature:query:value';
var FEATURE_QUERY_ENABLED = 'feature:query:enabled';
var FEATURE_QUERY_ACTIVE = 'feature:query:active';
var FEATURE_UPDATED = 'feature:updated';
(function (Feature) {
    // Boolean based values
    Feature["COOKIE_POPUP"] = "cookie-popup";
    Feature["FAQS"] = "faqs";
    Feature["RESPONSIBLE_GAMING_PAGE"] = "responsible-gaming-page";
    Feature["ABOUT_US"] = "about-us";
    Feature["MESSAGES"] = "messages";
    Feature["LEADERBOARDS"] = "leaderboards";
    Feature["POP_OPEN_MESSAGES_AS_MODALS"] = "pop-open-messages-as-modals";
    Feature["PROMOTIONS"] = "promotions";
    Feature["REWARDS"] = "rewards";
    Feature["MARKETING_PREFERENCES"] = "marketing-preferences";
    Feature["VERIFICATION"] = "verification";
    Feature["SOURCE_OF_WEALTH"] = "source-of-wealth";
    Feature["RESPONSIBLE_GAMING_QUESTIONNAIRE"] = "responsible-gaming-questionnaire";
    Feature["TOURNAMENTS"] = "tournaments";
    Feature["QUICK_DEPOSIT"] = "quick-deposit";
    Feature["PASSWORD_RESET_EMAIL"] = "password-reset-email";
    Feature["PASSWORD_RESET_SMS"] = "password-reset-sms";
    Feature["LOYALTY_PROGRESS_BAR"] = "loyalty-progress-bar";
    Feature["LOYALTY_PROGRESS_BAR_GAME_NAVIGATION"] = "loyalty-progress-bar-game-navigation";
    Feature["SHOP"] = "shop";
    Feature["HYBRID_PNP_BONUS_NOTIFICATION"] = "hybrid-pay-and-play-bonus-notification";
    Feature["SEO_TEXT_GAMES_CATEGORIES"] = "seo-text-games-categories";
    Feature["DYNAMIC_OPTION_MOBILE_BOTTOM_MENU"] = "dynamic-option-mobile-bottom-menu";
    Feature["REWARD_DETAIL_IMAGE"] = "reward-details-image";
    Feature["COLLAPSIBLE_MARKETING_PREFERENCES"] = "collapsible-marketing-preferences";
    Feature["DISPLAY_MESSAGE_IMAGE"] = "display-message-image";
    Feature["BANK_ID_REGISTRATION_SECURITY_QUESTIONS"] = "bank-id-registration-security-questions";
    Feature["WAKE_LOCK"] = "wake-lock";
    Feature["MAIL_CHECK"] = "mail-check";
    Feature["AMEND_DOB_HINT"] = "amend-dob-hint";
    Feature["VERIFICATION_EMAIL_CLIENTS"] = "verification-email-clients";
    Feature["REWARDS_DATE_FILTER"] = "rewards-date-filter";
    Feature["BANK_ID_ENABLED"] = "bank-id-enabled";
    Feature["BONUS_TRANSACTION_HISTORY"] = "bonus-transaction-history";
    Feature["PAYMENTS_TRANSACTION_HISTORY"] = "payments-transaction-history";
    Feature["PURCHASE_TRANSACTION_HISTORY"] = "purchase-transaction-history";
    Feature["REDEMPTION_TRANSACTION_HISTORY"] = "redemption-transaction-history";
    Feature["UNMASK_PASSWORD"] = "unmask-password";
    Feature["STATUS_PAYMENT_TRANSACTIONS"] = "status-payment-transactions";
    Feature["TRANSACTIONS_HISTORY_ON_LOCAL_TIME"] = "transactions-history-on-local-time";
    Feature["GRE_TRACKING_EVENTS"] = "gre-tracking-events";
    Feature["SUBDIVISION_REQUIRED"] = "subdivision-required";
    Feature["CASHIER_PENDING_WITHDRAWALS"] = "cashier-pending-withdrawals";
    Feature["PROMOTION_GAMES"] = "promotion-games";
    Feature["WALLET_METHOD_REMOVAL"] = "wallet-method-removal";
    Feature["REMAINING_DEPOSIT_LIMIT_AMOUNT"] = "remaining-deposit-limit-amount";
    Feature["HREFLANG_ON_PAGE"] = "hreflang-on-page";
    Feature["SHOW_EXPIRY_DATE"] = "expiry-date-on-rewards";
    Feature["SPORTNCO_META_CONTENT"] = "sportnco-meta-content";
    Feature["AGCO_TOP_BAR"] = "agco-top-bar";
    Feature["DISABLE_WITHDRAWAL_REVERSE"] = "disable-withdrawal-reverse";
    Feature["SPORTSBOOK"] = "sportsbook";
    Feature["ENHANCED_LIMITS"] = "enhanced-limits";
    Feature["ENHANCED_TAG_ON_THUMBNAILS"] = "enhanced-tags-on-thumbnails";
    Feature["SHOW_SHOP_SELECTION_SCREEN"] = "show-shop-selection-screen";
    Feature["SPORTSBOOK_CAROUSEL"] = "sportsbook-carousel";
    Feature["SCAN_VERIFY_FLOW"] = "scan-verify-flow";
    Feature["SCAN_DOCUMENTS_FLOW"] = "scan-documents-flow";
    Feature["CUSTOM_WELCOME_OFFER_BASED_ON_BTAG"] = "custom-welcome-offer-based-on-btag";
    Feature["MYSTERY_REWARDS"] = "mystery-rewards";
    Feature["FREE_TO_PLAY_LOBBY"] = "free-to-play-lobby";
    Feature["COLLAPSIBLE_SIDE_MENU"] = "collapsible-side-menu";
    Feature["SUBDIVISION_ON_GAME_LAUNCH"] = "subdivision-code-on-game-launch";
    Feature["STICKY_SUB_TOP_NAVIGATION"] = "sticky-sub-top-navigation";
    Feature["LOYALTY_PROGRAM"] = "loyalty-program";
    Feature["PERSONALISED_OFFERS"] = "personalised-offers";
    Feature["ABBREVIATE_SWEEPCOINS"] = "abbreviate-sweepcoins";
    Feature["VIDEOS_ON_MESSAGES"] = "videos-on-messages";
    Feature["PHONE_VERIFICATION_REQUIRED"] = "phone-verification-required";
    Feature["SPORTSBOOK_HISTORY"] = "sportsbook-history";
    Feature["MOBILE_SEARCH_KEYBOARD"] = "mobile-search-keyboard";
    Feature["CASHIER_POPULATE_DEPOSIT_AMOUNT"] = "cashier-populate-deposit-amount";
    Feature["PROMOTIONAL_OFFERS_SIGNUP"] = "promotional-offers-signup";
    Feature["FORMAT_JACKPOT_TICKER"] = "format-jackpot-ticker";
    Feature["ANIMATE_COIN_SHOP_BUTTON"] = "animate-coin-shop-button";
    Feature["CAROUSEL_HIGH_RESOLUTION"] = "carousel-high-resolution";
    Feature["ENHANCED_GAMES_GRID"] = "enhanced-games-grid";
    Feature["GAMEPLAY_RELOAD"] = "gameplay-reload";
    Feature["FREE_TO_PLAY_BALANCE"] = "free-to-play-balance";
    Feature["FREE_COINS_TRANSACTION_HISTORY"] = "free-coins-transaction-history";
    Feature["PREPOPULATE_USERNAME_KC"] = "prepopulate-username-on-keycloak";
    Feature["PAYMENT_TRANSACTION_HISTORY_ALTERNATIVE_LAYOUT"] = "payment-transaction-history-alternative-layout";
    Feature["PROOF_OF_ID_ON_PROFILE"] = "proof-of-id-on-profile";
    Feature["PAYMENT_TRANSACTIONS_SEARCH_ALL"] = "payment-transactions-search-all";
    Feature["ENHANCED_GALLEON_CASHIER_CONFIGURATION"] = "enhanced-galleon-cashier-configuration";
    Feature["REDIRECTION_TO_VERIFICATION_SECTION"] = "redirection-to-verification-section";
    Feature["ENABLE_CATEGORY_BACKGROUND"] = "game-category-background";
    Feature["SQUARE_GAME_THUMBNAILS"] = "square-game-thumbnails";
    Feature["CANCEL_DEPOSIT_LIMITS"] = "cancel-deposit-limits";
    Feature["MDY_FORMAT"] = "mdy-format";
    Feature["REGISTRATION_MERGED_TERMS"] = "registration_merged_terms";
    Feature["USER_RESTRICTIONS_CUSTOM_MODAL"] = "user-restrictions-custom-modal";
    Feature["DISABLE_MANUAL_UPLOAD"] = "disable-manual-upload";
    Feature["ALLOW_ALL_DOCUMENTS_UPLOAD"] = "allow-all-documents-upload";
    Feature["PERIODIC_ACCOUNT_REVIEW"] = "periodic_account_review";
    Feature["SHOW_BACK_HOME_LINK_ON_LOGIN_PAGE"] = "show-back-home-link-on-login-page";
    // String array values
    Feature["ACCOUNT_MENU"] = "account-menu";
    Feature["PASSWORD_RESET"] = "password-reset";
    Feature["TWO_FACTOR_AUTHENTICATION_SIGN_UP"] = "two-factor-authentication-sign-up";
    Feature["TWO_FACTOR_AUTHENTICATION_MY_ACCOUNT"] = "two-factor-authentication-my-account";
    Feature["GAMES_PROVIDERS_FILTER"] = "games-providers-filter";
    Feature["GAMES_ENHANCED_PROVIDERS_FILTER"] = "games-enhanced-providers-filter";
    Feature["HYBRID_PAY_AND_PLAY"] = "hybrid-pay-and-play";
    Feature["PURE_PAY_AND_PLAY"] = "pure-pay-and-play";
    Feature["PURE_PAY_AND_PLAY_COLLECT_MARKETING_INFO"] = "pure-pay-and-play-collect-marketing-info";
    Feature["SOCIAL_MEDIA_ICONS_FOOTER"] = "social-media-icons-footer";
    Feature["QUICK_DEPOSIT_PROVIDERS_RELOAD"] = "quick-deposit-providers-reload";
    Feature["RECOMMENDED_GAMES_MARKET"] = "recommended-games-market";
    Feature["RECOMMENDED_GAMES_USER"] = "recommended-games-user";
    Feature["SEASONAL_REWARD"] = "seasonal-reward";
    Feature["GAMEPLAY_INFORMATION_DISABLED"] = "gameplay-information-disabled";
    Feature["RESPONSIBLE_GAMING_FEATURES"] = "responsible-gaming-features";
    Feature["WHEEL_REWARD"] = "wheel-reward";
    Feature["DASHBOARD"] = "dashboard";
    Feature["BONUS_CODE_CASHIER"] = "bonus-code-cashier";
    Feature["DEPOSIT_BONUS_CASHIER"] = "deposit-bonus-cashier";
    Feature["CAROUSEL_LOGGED_OUT"] = "carousel-logged-out";
    Feature["BINGO_LOBBY"] = "bingo-lobby";
    Feature["GAME_PROVIDER_DROPDOWN"] = "game-provider-dropdown";
    Feature["IFRAME_GAME_PROVIDERS"] = "game-providers-loaded-via-iframe";
    Feature["ALLOWED_COUNTRIES"] = "allowed-countries";
    Feature["TIMED_TOAST_NOTIFICATIONS"] = "timed-toast-notifications";
    Feature["MERCHANT_ID"] = "merchant-id";
    Feature["TOP_NAVIGATION"] = "top-navigation";
    Feature["SAVED_DEPOSIT_CARDS"] = "saved-deposit-cards";
    Feature["DYNAMIC_CATEGORY"] = "dynamic-category-recommendations";
    Feature["GTM_ID"] = "gtm-id";
    Feature["CAROUSEL_WITHOUT_TEXT"] = "carousel-without-text";
    Feature["ENHANCED_CAROUSEL"] = "enhanced-carousel";
    Feature["LIGHT_CAROUSEL"] = "light-carousel";
    Feature["DEDICATED_HOMEPAGE"] = "dedicated-homepage";
    Feature["FREE_TO_PLAY_SOCIAL"] = "free-to-play-social";
    Feature["SWEEPCOINS_RATIO"] = "sweepcoins-ratio";
    Feature["SWEEPSTAKES_DIAMOND_COINS"] = "sweepstakes-diamond-coins";
    Feature["PAYMENTS_CLOSED_LOOP"] = "payments-closed-loop";
    Feature["SHOW_RATIO_BETWEEN_SWEEPCOINS_AND_FIAT"] = "show-ratio-between-sweepcoins-and-fiat";
    Feature["SWEEPCOINS_ANIMATION_TRANSITION"] = "sweepcoins-animation-transition";
    Feature["HIDE_SWEEPX_BALANCE_ON_GAMEPLAY"] = "hide-sweepx-balance-on-gameplay";
    Feature["SSN_REQUIRED_BEFORE_PURCHASE"] = "ssn-required-before-purchase";
    Feature["PAYSAFE_SKRILL_CLOSED_LOOP"] = "paysafe-skrill-closed-loop";
    Feature["PAYSAFE_SKRILL_ALLOW_SEVERAL_WITHDRAWAL_ACCOUNTS"] = "paysafe-skrill-allow-several-withdrawal-accounts";
    Feature["SKIP_INTERMIDIATE_REDIRECT_STEP"] = "skip-intermediate-step-redirect-methods";
    Feature["ENHANCED_GAME_CATEGORIES"] = "enhanced-game-categories";
    Feature["NON_SCROLLABLE_GAMES"] = "non-scrollable-games";
    Feature["FREE_TO_PLAY_HOMEPAGE"] = "free-to-play-homepage";
    Feature["CAROUSEL_ON_SUBCATEGORIES"] = "carousel-on-subcategories";
    Feature["ENHANCED_COVERS_ON_STATIC_PAGES"] = "enhanced-covers-on-static-pages";
    Feature["LEADERBOARD_LIMITS"] = "leaderboard-limit";
    Feature["STREAMING_LOBBY_URL"] = "streaming-lobby-url";
    Feature["ALWAYS_ALLOW_DOCUMENT_UPLOAD"] = "always-allow-document-upload";
    Feature["ENABLE_SMARTICO_WIDGET"] = "enable-smartico-widget";
    Feature["ADDRESS_AUTOCOMPLETE"] = "address-autocomplete";
    Feature["TRIGGER_KYC_VERIFICATIONS_BEFORE_ENTERING_REDEMPTION_SHOP"] = "trigger-kyc-verifications-before-entering-redemption-shop";
    Feature["TRIGGER_KYC_VERIFICATIONS_BEFORE_SELECTING_SHOP_REDEMPTION_METHOD"] = "trigger-kyc-verifications-before-selecting-shop-redemption-method";
    Feature["TRIGGER_KYC_VERIFICATIONS_BEFORE_ENTERING_COIN_SHOP"] = "trigger-kyc-verifications-before-entering-coin-shop";
    Feature["TRIGGER_KYC_VERIFICATIONS_BEFORE_SELECTING_COIN_SHOP_PURCHASE_METHOD"] = "trigger-kyc-verifications-before-selecting-coin-shop-purchase-method";
    Feature["EYE_ABLE_ENABLED"] = "eye-abled-enabled";
})(exports.Feature || (exports.Feature = {}));
(function (FeatureSettings) {
    // top navigation
    FeatureSettings["LEFT_SIDE_MENU"] = "left-side-menu";
    FeatureSettings["BOTTOM_NAVIGATION_ENABLED"] = "bottom-navigation-enabled";
    FeatureSettings["PAYSAFE_SKRILL_CLOSED_LOOP"] = "paysafe-skrill-closed-loop";
})(exports.FeatureSettings || (exports.FeatureSettings = {}));

exports.FEATURE_QUERY_ACTIVE = FEATURE_QUERY_ACTIVE;
exports.FEATURE_QUERY_ENABLED = FEATURE_QUERY_ENABLED;
exports.FEATURE_QUERY_VALUE = FEATURE_QUERY_VALUE;
exports.FEATURE_UPDATED = FEATURE_UPDATED;
